import { css } from 'styled-components';

// QuickBrush
import QuickBrush2 from '../fonts/QuickBrush-Web.woff2';
import QuickBrush from '../fonts/QuickBrush-Web.woff';

export default css`
  @font-face {
    font-family: 'Quickbrush';
    font-weight: normal;
    font-style: normal;
    src: url('${QuickBrush2}') format('woff2'),
        url('${QuickBrush}') format('woff');
    font-display: swap;
  }
`;
